import { makeStyles } from "tss-react/mui"
import { Box, Stack, Skeleton } from "@mui/material"

const useStyles = makeStyles()(() => ({
    wrap: {
        width: "100%",
    },
    metadataGrid: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "2rem",
    },
    detailBlock: {
        display: "flex",
        flexDirection: "column",
        gap: ".375rem",
    },
}))

const METADATA_ROWS = 6

export function ResourceDetailsDialogSkeleton() {
    const { classes } = useStyles()

    return (
        <Stack gap="2rem" className={classes.wrap}>
            <Skeleton variant="rectangular" width="100%" height="15rem" />
            <Box className={classes.detailBlock}>
                <Skeleton variant="text" width="40%" height="1.5rem" />
                <Skeleton variant="text" width="100%" height="1.25rem" />
                <Skeleton variant="text" width="80%" height="1.25rem" />
            </Box>
            <Box className={classes.metadataGrid}>
                {Array.from({ length: METADATA_ROWS }).map((_, i) => (
                    <Box key={i} className={classes.detailBlock}>
                        <Skeleton variant="text" width="60%" height="1.5rem" />
                        <Skeleton variant="text" height="1.25rem" />
                    </Box>
                ))}
            </Box>
        </Stack>
    )
}
